import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';
import { CommonMessages } from 'src/app/shared/messages/messages.enum';

@Component({
  selector: 'app-list-media-sub',
  templateUrl: './list-media-sub.component.html',
  styleUrls: ['./list-media-sub.component.css']
})
export class ListMediaSubComponent extends BaseComponent implements OnInit {

  @ViewChild('searchText', { static: true }) searchText: ElementRef;

  companyID = 0;
  selectedCompany : any = '';
  currentUser;
  getCompanyobj: any = [];
  mediaSubData: any = [];
  mediaSubTotal: number = 0;
  slCatPage = 1;
  slCatLimit = 20;
  slCatSkip = 0;
  slCatord = "asc";
  slCatColname = "media_name";
  planColumns: any[] = [];
  constructor(private clientService: ClientService,
    private masterService:MasterService) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));

    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;
      this.selectedCompany = this.companyID;
      this.getSubscriptionList();
    }
    if (this.currentUser.admin_customer_id == '0') this.getCompany();
  }
  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      const working = this.bindWorkingCompany(this.getCompanyobj);
      if (working) {
        this.selectedCompany = working;
        this.getSubscriptionList();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }

  onCompanyChange(value?: any) {
    if (value !== undefined) {
      this.selectedCompany = value;
    }
    this.slCatPage = 1;
    this.getSubscriptionList();
  }
  resetFilters() {
    this.slCatPage = 1;
    this.slCatSkip = 0;
    if (this.searchText && this.searchText.nativeElement) {
      this.searchText.nativeElement.value = '';
    }
    if (this.companyID == 0) {
      this.selectedCompany = this.bindWorkingCompany(this.getCompanyobj) || '';
    }
    this.getSubscriptionList();
  }
  getSubscriptionList() {
    let searchTerm = this.searchText.nativeElement.value;
    this.slCatSkip = (this.slCatPage - 1) * this.slCatLimit;

    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();

      this.masterService.getSubscriptionMediaList(this.selectedCompany,this.slCatLimit, this.slCatSkip, searchTerm,this.slCatColname,this.slCatord).subscribe(data => {
        this.ngxSpinnerService.hide();
        // console.log(data);

        if (data.status) {
          if (data.data.rows == null) { this.mediaSubData = [] }
          else { this.mediaSubData = data.data.rows }
          this.mediaSubTotal = data.data.total;
          this.planColumns = data.data.plan_columns || [];
        } else {
          this.mediaSubData = [];
          this.mediaSubTotal = 0;
          this.planColumns = [];
        }
      }, error => { console.log(error);this.ngxSpinnerService.hide(); });
    } else {
      this.mediaSubData = [];
      this.selectedCompany = "";
      this.mediaSubTotal = 0;
      this.planColumns = [];
      this.ngxSpinnerService.hide();
    }
  }
  planPointDisplay(row: any, slug: string) {
    if (!row || !row.has_plan_rates) {
      return '—';
    }
    const points = row.plan_points || {};
    if (points[slug] === undefined || points[slug] === null || points[slug] === '') {
      return row.point;
    }
    return points[slug];
  }
  setOrder(value: string) {
    this.slCatColname = value
    if (this.slCatord == 'asc') {
      this.slCatord = 'desc'
    } else {
      this.slCatord = 'asc'
    } this.getSubscriptionList()
  }
  editPost(id:any) {
    localStorage.setItem("edit_subscription_media_id", id);
    localStorage.setItem("edit_subscription_media_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/edit-subscription-media']);
  }
  updateStatus(event, id, status) {
    event.preventDefault();
    let obj = {
      isactive: (status == true) ? false : true,
      // company:this.selectedCompany,
      // id:id
    }
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To' + ((obj.isactive) ? ' Active?' : ' In Active?'), 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.updateSubscriptionMediaStatus(this.selectedCompany,id,obj).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Status Updated Successfully");
              this.getSubscriptionList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  delSubscription(event, id) {
    event.preventDefault();
    this.confirmationDialogService.confirm('Please confirm', 'ARE YOU SURE YOU WANT TO DELETE ?', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.deleteSubscriptionMedia(this.selectedCompany,id).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Status Deleted Successfully");
              this.getSubscriptionList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    this.ngxSpinnerService.show();
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.slCatSkip = 0;
          this.slCatPage = 1;
        }),

        switchMap(data => this.masterService.getSubscriptionMediaList(this.selectedCompany,this.slCatLimit, this.slCatSkip, this.searchText.nativeElement.value,this.slCatColname,this.slCatord))

      )
      .subscribe(res => {
        if (res.status) {
          if (res.data.rows == null) { this.mediaSubData = [] }
          else { this.mediaSubData = res.data.rows }
          this.mediaSubTotal = res.data.total;
          this.planColumns = res.data.plan_columns || [];
        } else {
          this.mediaSubData = [];
          this.mediaSubTotal = 0;
          this.planColumns = [];
        }
        this.ngxSpinnerService.hide();
      },error => {
        this.mediaSubData = [];
        this.mediaSubTotal = 0;
        this.planColumns = [];
        this.ngxSpinnerService.hide();
      });
  }

}
